module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1026-d082fa8fcbf4ff81d02aa16316db0820.png";